<template>
  <div class="w-full flex flex-col justify-center items-center gap-2">
    <feather-icon icon="AlertTriangleIcon" svgClasses="h-10 w-10 text-grey"/>
    <p class="text-grey font-medium">{{ $t('You do not have permission to') + ' ' + action }}</p>
  </div>
</template>

<script>
export default {
  props: ['action']
}
</script>